import React, { useEffect, useState } from "react";
import axios from "axios";
import Card from "./Card";

function PastEvents({ slug }) {
  const [pastEvents, setPastEvents] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  console.log(pastEvents)

  const fetchPastEvents = async (pageNum = 1) => {
    setLoading(true);
    try {
      const Url = `${BASE_URL}/api/user/events/${slug}/past?limit=8&page=${pageNum}`;

      const res = await axios.get(Url, {
        headers: {
          Authorization: `Bearer ${API_KEY}`,
          Accept: "application/json",
        },
      });


      let responseData = [];
      if (
        res.data &&
        res.data.data &&
        Array.isArray(res.data.data.data)
      ) {
        responseData = res.data.data.data;
      } else if (res.data && Array.isArray(res.data.data)) {
        responseData = res.data.data;
      }

      setPastEvents((prev) => [...prev, ...responseData]);

      const nextPageUrl =
        (res.data &&
          res.data.data &&
          res.data.data.next_page_url) ||
        (res.data && res.data.links && res.data.links.next) ||
        (res.data && res.data.meta && res.data.meta.next_page_url);

      setHasMore(Boolean(nextPageUrl));
    } catch (err) {
      console.error("Error fetching past events:", err);
      setError("Unable to fetch past events. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (slug) fetchPastEvents(page);
  }, [page, slug]);

  const handleLoadMore = () => {
    setPage((prev) => prev + 1);
  };

  if (error)
    return (null);

  return (
    <div className="container ">
      {pastEvents.length > 0 && (
        <div className="pt-3 pb-5">
          <h2 className="mb-4 text-center organizer-title">Past Events</h2>

          {pastEvents.length === 0 && !loading ? (
            <p className="text-center text-muted">No past events found.</p>
          ) : (
            <>
              <div className="row g-3">
                {pastEvents.map((event) => (
                  <div key={event.id} className="col-12 col-sm-6 col-lg-3">
                    <Card
                      image={
                        event.image_name
                          ? `${event.image_path}`
                          : "https://via.placeholder.com/400x300?text=No+Image"
                      }
                      title={event.name}
                      address1={event.address1}
                      location={event.location}
                      postalcode={event.postal_code}
                      startDate={event.start_date}
                      endDate={event.end_date}
                      startTicketDate={
                        event.ticket_start_at || event.start_date
                      }
                      type={event.category}
                      detail_url={`/events/${event.slug}`}
                      showStartDate={event.show_start_date}
                      price={
                        event.tickets && event.tickets.length > 0
                          ? event.tickets[0].price
                          : null
                      }
                      adultOnly={event.adult_event}
                    />
                  </div>
                ))}
              </div>

              {hasMore && (
                <div className="text-center mt-5">
                  <button
                    onClick={handleLoadMore}
                    disabled={loading}
                    className="btn btn-dark px-4 py-2 rounded-pill"
                  >
                    {loading ? "Loading..." : "Load More"}
                  </button>
                </div>
              )}
            </>
          )}

          {loading && pastEvents.length === 0 && (
            <div className="text-center py-4">Loading events...</div>
          )}
        </div>
      )
      }

    </div>
  );
}

export default PastEvents;
